import { Component } from '@theme/component';

/**
 * @typedef {Object} SellingPlanSelectorRefs
 * @property {HTMLInputElement} sellingPlanId
 */

/**
 * Keeps the hidden `selling_plan` add-to-cart field in sync with whichever
 * purchase option card (subscription or one-time purchase) is selected, and
 * mirrors that option's price into the sticky add-to-cart bar and the main
 * product price display, which otherwise only update on variant changes.
 *
 * @extends {Component<SellingPlanSelectorRefs>}
 */
class SellingPlanSelector extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updateSellingPlan();
  }

  updatedCallback() {
    super.updatedCallback();
    this.updateSellingPlan();
  }

  updateSellingPlan() {
    const { sellingPlanId } = this.refs;
    if (!sellingPlanId) return;

    const selected = /** @type {HTMLInputElement | null} */ (this.querySelector('input[type="radio"]:checked'));
    sellingPlanId.value = selected?.dataset.sellingPlanId ?? '';

    if (selected?.dataset.priceHtml) {
      this.#updateMainPriceDisplay(selected.dataset.priceHtml);
    }

    if (selected?.dataset.price) {
      this.#updateStickyPrice(selected.dataset.price);
    }
  }

  /**
   * @param {string} priceHtml
   */
  #updateMainPriceDisplay(priceHtml) {
    const section = this.closest('.shopify-section');
    if (!section) return;

    const priceContainer = section.querySelector('product-price [ref="priceContainer"]');
    if (priceContainer) priceContainer.innerHTML = priceHtml;
  }

  /**
   * @param {string} price - The selected plan's unit price, in minor currency units
   */
  #updateStickyPrice(price) {
    const section = this.closest('.shopify-section');
    if (!section) return;

    const stickyAddToCart = /** @type {any} */ (section.querySelector('sticky-add-to-cart'));
    stickyAddToCart?.updateUnitPrice?.(price);
  }
}

if (!customElements.get('selling-plan-selector')) {
  customElements.define('selling-plan-selector', SellingPlanSelector);
}
